import theLastScarceThing from "./articles/the-last-scarce-thing";

// Articles registry. Newest first. Add new articles by importing here.
export const articles = [theLastScarceThing];

export const articlesBySlug = Object.fromEntries(
  articles.map((a) => [a.slug, a])
);

export const getArticle = (slug) => articlesBySlug[slug];
